var tw = tw || {};
tw.BandwangoLanding = (function () {
	var _log = false,
		holdData = null,
        initUgc = true,
		isMobile = false,
		lastIsMobile = null,
		mobileBreak = 768,        
        to_resize = null
		;

	if (_log) console.log('init.tw.BandwangoLanding.js');

    // TEMPLATES
    var heroImgTemplate = $('#heroImgTemplate').html(),
        section1Template = $('#section1Template').html(),
        prizeCardTemplate = $('#prizeCardTemplate').html(),
        instructionCardTemplate = $('#instructionCardTemplate').html(),
        newsletterCalloutImg = $('#newsletterCalloutImg').html();


    var initAOS = function(){
        AOS.init({
			duration: 250,
			easing: 'ease-in-out-quart',
			offset: 100,
			once: true,
        });
    }


	/**
	 * Initialize page
	 */
	var initializePage = function () {
		//if (_log) console.log('initializePage()');

		getContent('/JS/tw/contentpages/data/bandwango.json');
	}

	/**
	 * Get content from local json
	 * @param {*} dataPath 
	 */
	var getContent = function (dataPath) {
		if (_log) console.log('getContent()', dataPath);
        $('.js-loader').html('<div class="progress-spinner"></div>');
		var jqxhr = $.getJSON(dataPath, function (data) {
			if (_log) console.log( "getContent.data:", data);

				holdData = data;
				processContent(data);
			})
			.fail(function (err) {
				console.error("error:", err);
			});
	}


	/**
	 * Process content from JSON file, Shuffle, trim array
	 * @param {*} data 
	 */
	var processContent = function (data) {
        setTimeout(() => {
            initAOS();
        }, 700);

        // HERO SECTION
        if(data.hero) {
            $('.js-hero-section h1').html(data.hero.heading)
            var compiledVideoTemplate = Template7.compile(heroImgTemplate);
            var heroImgHtml = '';
            var jsonContent = {
                imageUrlSmall: data.hero.backgroundImageMobile,
                imageUrlLarge: data.hero.backgroundImageDesktop,
                heading: data.hero.heading
            };
            heroImgHtml += compiledVideoTemplate(jsonContent);
            $('.js-hero-section').append(heroImgHtml);
        }

        if (data.section1) {
            $('.js-section1-title').html(data.section1.title);
            $('.js-section1-kicker').html(data.section1.kicker);
            $('.js-section1-heading').html(data.section1.heading);
            $('.js-section1-description').html(data.section1.description);
            $('.js-section1-contentHeader').html(data.section1.contentHeader);

            var compiledSec1Template = Template7.compile(section1Template);
            var sec3CardHtml = compiledSec1Template({"contentList": data.section1.contentList});
            $('.js-section1-contentList').html(sec3CardHtml);            
        }

        if (data.section2) {
            $('.js-instructions-heading').html(data.section2.heading);

            var compiledDealCardsTemplate = Template7.compile(instructionCardTemplate);
            var sec3CardHtml = compiledDealCardsTemplate({"contentCards": data.section2.content});
            $('.js-instructions-content').html(sec3CardHtml);
        }

        if (data.section3) {
            setContainerMargin();            
            $('.js-prizes-heading').html(data.section3.heading);
            $('.js-prizes-description').html(data.section3.description);

            var compiledDealCardsTemplate = Template7.compile(prizeCardTemplate);
            var sec6CardHtml = compiledDealCardsTemplate({"prizesCards": data.section3.prizesCards});
            $('.js-prizes-slick').html(sec6CardHtml);

            $('.js-prizes-slick').slick({
                // infinite: true,
                infinite: false,
                prevArrow: $('.js-prizes-prev'),
                nextArrow: $('.js-prizes-next'),
                variableWidth: false,
                mobileFirst: true,
                // slidesToShow: 1,
                // slidesToScroll: 1,
                // draggable: false,
                responsive: [
                    {
                        breakpoint: 0,
                        settings: {
                            slidesToShow: 1.1,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 425,
                        settings: {
                            slidesToShow: 1.5,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2.25,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            // infinite: true,
                            // slidesToScroll: 1,
                            // draggable: false,
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 2.5,  
                            // infinite: true,                                                      
                            // slidesToScroll: 1,
                            // draggable: false,
                        }
                    },
                    // {
                    //     breakpoint: 1400,
                    //     settings: {
                    //         slidesToShow: 4,
                    //         // slidesToScroll: 1,
                    //         // draggable: false,
                    //     }
                    // },
                    {
                        breakpoint: 1800,
                        settings: {
                            slidesToShow: 2.9,
                            // infinite: true,
                            // draggable: false,
                        }
                    },
                ]
            });
        }
        if (data.section4) {
            $('.js-5050-heading').html(data.section4.heading);
            $('.js-5050-description').html(data.section4.description);
            $('.js-5050-cta').attr('href', data.section4.cta.url);
            $('.js-5050-cta').html(data.section4.cta.text);
            $('.js-5050-image').attr({
                'src': data.section4.backgroundImage + '?width=700&height=475&scale=both&mode=crop',
                'alt': data.section4.backgroundImageDescription
            });
        }
        

        if (data.section5) {
            /**
             * Initialize User Generated Content
             * 
             * USE VANILLA JS FOR CROWDRIFF. USING JQUERY COMMANDS WILL BREAK PATHING SCOPE.
             * $('#loaderUGC').append(s);//<--will break
             * loaderUGC.append(s);//<--will also break on IE. use appendChild
             * 
             * @param {*} data 
             * @param {*} divId 
             */
            var initializeUGC = function (data, divId) {
                // if (_log) console.log('initializeUGC');
                // if (_log) console.log('ugc.data:', data);
                //if (_log) console.log('window1:', window);

                if (!initUgc) {
                    //If UGC has been initialized already, clear out the rendered array
                    window.crowdriff__gallery.rendered = [];
                    //if (_log) console.log('window.crowdriff__gallery:', window.crowdriff__gallery);
                }
                $('#' + divId).html('');//clear out div

                var s = document.createElement("script");
                s.type = "text/javascript";
                s.src = "https://starling.crowdriff.com/js/crowdriff.js";
                s.id = data; //"ex: cr-init__1b59e2be8c775f33"
                var loaderUGC = document.getElementById(divId);
                loaderUGC.appendChild(s);
                //if (_log) console.log('appendChild.s:', s);

                if (!initUgc) {
                    //If UGC has been initialized already, restart interval to process Queue
                    //if (_log) console.log('window.crowdriff__gallery.interval:', window.crowdriff__gallery.interval);
                    if (window.crowdriff__gallery && !window.crowdriff__gallery.interval) {
                        window.crowdriff__gallery.interval = setInterval(window.crowdriff__gallery.processQueue, 300);
                    }
                }
                initUgc = false;
            }
            // Inject Copy
            $('.js-ugc-heading').html(data.section5.heading);
            $('.js-ugc-copy').html(data.section5.copy);
            // Initialize UGC
            setTimeout(initializeUGC, 3000, data.section5.crowdRiffId , "photoGallery");
            // initializeUGC(data.section4.crowdRiffId , "photoGallery");
        }


        if(data.newsletterCallout) {
            $('.js-callout-kicker').html(data.newsletterCallout.kicker);
            $('.js-callout-heading').html(data.newsletterCallout.heading);
            $('.js-callout-button').attr('href', data.newsletterCallout.cta.link);
            $('.js-callout-button').html(data.newsletterCallout.cta.text);
            
            var compiledCalloutImageTemplate = Template7.compile(newsletterCalloutImg);
            var calloutImgHtml = '';
            var calloutJsonContent = {
                calloutImageUrlSmall: data.newsletterCallout.backgroundImageMobile,
                calloutImageUrlLarge: data.newsletterCallout.backgroundImageDesktop
            };
            calloutImgHtml += compiledCalloutImageTemplate(calloutJsonContent);
            // if (_log) console.log(calloutJsonContent);
            $('.js-newsletter-callout').append(calloutImgHtml);
        }
        $('.js-loader').remove();
	}

    const setContainerMargin = () => { 
        const getContainer = window.document.querySelector('.container');
        const applicationContainer = document.querySelectorAll('.js-prizes');
        applicationContainer.forEach(container => {
            container.style.marginLeft = getContainer.offsetLeft + "px";
        })
    }

    setTimeout(() => {
        // Prizes Slider Image Modals
        const contentModalTriggers = document.querySelectorAll(".js-content-modal-trigger");

        contentModalTriggers.forEach((trigger) => {
            trigger.addEventListener("click", (e) => {
                e.preventDefault();
                const contentModal = document.querySelector('[data-modal-id="' + trigger.dataset.modalTarget + '"]');
                const closeButton = contentModal.querySelector('.js-content-dialog-close');

                document.body.classList.add('overflow-hidden');
                contentModal.showModal();    
                closeButton.addEventListener("click", () => {
                    contentModal.close();
                    document.body.classList.remove('overflow-hidden');
                });
    
                contentModal.addEventListener("close", () => {
                    document.body.classList.remove('overflow-hidden');
                });

                window.addEventListener("click", (event) => {
                    if (event.target === contentModal) {
                        contentModal.close();
                        document.body.classList.remove('no-scroll');
                    }
                });
            });
        });
    }, 1000);


    /**
     * Open Bandwango signup modal
     * Need additional data-attrs that are located on the div class below
    */
    var openBWModal = function () {
        $('.bw-gtm-a2c').trigger('click');
    }

	/**
	 * Trigger methods on resize
	*/
	var trackResize = function () {
		if (_log) console.log('trackResize()');
        setContainerMargin();
	}

	$(window).resize(function () {
		//console.log('resize');
		clearTimeout(to_resize);
		to_resize = setTimeout(function () {
			//console.log('to_resizeto_resizeto_resizeto_resizeto_resizeto_resize');
			trackResize();
		}, 100);
	});

    window.addEventListener("load", () => {
        setContainerMargin();
    });

	$(initializePage); //doc ready

    return{
        openBWModal: openBWModal
    }

}());